import Vue from 'vue';
import upperFirst from 'lodash/upperFirst';
import camelCase from 'lodash/camelCase';

const requireComponents = require.context('.', true, /\.vue$/);

requireComponents.keys().forEach(fileName => {
  const componentConfig = requireComponents(fileName);
  const componentToRegister = componentConfig.default || componentConfig;
  var componentName = upperFirst(camelCase(componentToRegister.name));
  if (componentName) {
    Vue.component(componentName, componentToRegister);
  } else {
    console.error('Nincs komponens név: ', fileName);
  }
});
